/**
 * Queries every discrepancy mutation refetches. The event history expanders
 * and the header's Blocked chip (ManifestBlockState) read their own queries,
 * and resolving the last open finding clears the block server-side.
 */
export const DISCREPANCY_MUTATION_REFETCH_QUERIES = [
  "ProcessedManifests",
  "ComplianceManifestData",
  "DiscrepancyEvents",
  "ManifestBlockState",
  "BulkManifestDiscrepancies",
];
